module.exports = __webpack_public_path__ + "img/5.aea1b5e0.jpg";